import { Route, Routes } from "react-router-dom";
import InfoPage from "../pages/InfoPage/InfoPage";
import Main from "../pages/Main/Main";
import NotePage from "../pages/FAQ/FAQPage";
import StatisticsPage from "../pages/StatisticPage/StatisticsPage";
import ArchivePage from "../pages/Archive/ArchivePage";


const AppRouter: React.FC = () => {
   return (
      <Routes>
         <Route path="/main" element={<Main />} />
         <Route path="/" element={<Main />} />
         <Route path="/info" element={<InfoPage />} />
         <Route path="/stat" element={<StatisticsPage />} />
         <Route path="/archive" element={<ArchivePage />} />
         <Route path="/note" element={<NotePage />} />
      </Routes>
   )
}

export default AppRouter;